'use client';

import clsx from 'clsx';

import { useAdmin } from '@/app/providers';

import { Icons } from './icons';

export function AdminEditLinkClient({
  apiBaseUrl,
  url,
  className,
}: {
  apiBaseUrl: string;
  url: string;
  className?: string;
}) {
  const isAdmin = useAdmin();

  if (isAdmin !== true) {
    return;
  }

  const editUrl = new URL(`/admin/content${url}`, apiBaseUrl);

  return (
    <a
      className={clsx('inline-flex', className)}
      href={editUrl.href}
      target="_blank"
      rel="noopener"
    >
      {Icons.pencil({ className: 'w-4 h-4 z-1 p-1 -mx-1 box-content' })}
    </a>
  );
}
